import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import RegisterButton from './components/RegisterButton';
import MediaNoticeContainer from './components/MediaNoticeContainer';
import Footer from './components/Footer';
import { localizations } from '../localization/localization';
import { connect } from 'react-redux';
import * as Store from '../admin/store/companiesStore';
import { ApplicationState } from '../store';
import { apiBaseUrl } from '../env';
import NewsContainer from './components/NewsContainer';
import MediaLogoInfoContainer from './components/MediaLogoInfoContainer';
import BrandColorsContainer from './components/BrandColorsContainer';

const styles = (theme: Theme) => createStyles({
  mainContainer: {
    minHeight: '100vh',
    backgroundColor: '#022639',
    fontFamily: 'Montserrat',
    fontSize: 16,
    letterSpacing: '0.0356em',
    lineHeight: 1.625,
    color: '#F7F8F9',
    [theme.breakpoints.down('md')]: {
      fontSize: 15
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    },
    '& > div:first-child': {
      color: 'white',
      fontSize: '2.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      marginBottom: '0.2941em'
    },
  },
  innerContainer: {
    maxWidth: 1440,
    marginTop: '48px',
  },
  innerContainerMobile: {
    maxWidth: 1440,
    marginTop: '38px',
  },
});

type MediaPageViewProps = Store.CompaniesState & typeof Store.actionCreators & WithStyles;
interface MediaPageViewState {
  registeredCompanies?: number;
  unitsAndTrucksTotal?: number;
  isMobile?: boolean;
}


class MediaPageView extends React.Component<MediaPageViewProps, MediaPageViewState> {
  constructor(props: MediaPageViewProps) {
    super(props);

    this.state = {
      isMobile: false
    }
  }

  public componentDidMount() {

    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    this.setState({
      isMobile: isMobileDevice
    })
  }

  public render() {
    const { classes } = this.props;
    const { registeredCompanies, unitsAndTrucksTotal, isMobile } = this.state;

    const isMobileDevice = isMobile;

    return (
      <Grid container direction="column" justify="center" alignItems="center" className={classes.mainContainer}>
        <Grid item>
        <h1>{localizations.mediaPageView.title}</h1>
        </Grid>
        <Grid item container direction="column" justify="center" alignItems="center" className={isMobile === false ? classes.innerContainer : classes.innerContainerMobile}>
          <MediaNoticeContainer isMobile={isMobile} />
          <MediaLogoInfoContainer isMobile={isMobile} />
          <BrandColorsContainer />
        </Grid>
        <Footer />
      </Grid>
    );
  }
}


export default connect<any>((state: ApplicationState) => state.companies, Store.actionCreators)(withStyles(styles)(MediaPageView));



// WEBPACK FOOTER //
// ./src/landingPage/MediaPageView.tsx